import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var NotFoundPage = function() {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("h1", {
                children: "404 - Page Not Found"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: "Sorry, the page you are looking for does not exist."
            })
        ]
    });
};
export default NotFoundPage;
